import React from 'react'
import LeftArrowIcon from 'react-icons/lib/md/keyboard-arrow-left'
import RightArrowIcon from 'react-icons/lib/md/keyboard-arrow-right'
import {useTranslation} from 'next-i18next'

import ProductsLoading from '../../Loading/Products'

import Products from './Products'
import useProducts from './useProducts'

import styles from './styles.module.css'

export default function Category(props) {
  const {category, storeId, deliverAt, menuId, setSelectedCategoryId, full} = props
  const {products, loading} = useProducts({
    categoryId: category._id,
    storeId,
    deliverAt,
    menuId,
    full
  })
  const {t} = useTranslation('generic')

  if (!loading && !products.length) return null

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.name}>{category.name}</div>
        <div
          className={styles.button}
          onClick={() => setSelectedCategoryId(full ? null : category._id)}>
          {full ? (
            <span>
              <LeftArrowIcon size={20} /> {t('fields.goBack')}
            </span>
          ) : (
            <span>
              {t('fields.showAll')} <RightArrowIcon size={20} />
            </span>
          )}
        </div>
      </div>
      {loading ? <ProductsLoading /> : <Products products={products} menuId={menuId} />}
    </div>
  )
}
